import * as React from "react";
import PropTypes from "prop-types";
import CalculateIcon from "@mui/icons-material/Calculate";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ShareIcon from "@mui/icons-material/Share";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import CircularProgress from "@mui/material/CircularProgress";
import { Box, Button, Stack, Typography } from "@mui/material";
import { useStyles } from "./indexStyles";
import { withStyles } from "@mui/styles";
import {
  SLUG_RECALCULATE,
  SLUG_BACK,
  SLUG_DOWNLOAD,
  SLUG_SHARE,
} from "../../../constants";

const CustomButton = ({
  classes: { button, buttonText, loaderStyle, mainCta },
  color = "primary",
  disabled = false,
  icon = false,
  isFormSubmitted = false,
  size = "large",
  slug = "",
  title = "Test Button",
  type = "submit",
  variant = "contained",
  clickHandler = () => {},
}) => {
  return (
    <Button
      type={type}
      size={size}
      variant={variant}
      color={color}
      className={button}
      fullWidth
      onClick={clickHandler}
      {...(disabled && {
        disabled: true,
      })}
    >
      <Box className={buttonText}>
        {!isFormSubmitted ? (
          icon ? (
            <Stack
              direction="row"
              gap={1}
              display={"flex"}
              justifyContent={"center"}
              alignItems={"center"}
            >
              {slug === SLUG_RECALCULATE && <CalculateIcon fontSize="small" />}
              {slug === SLUG_SHARE && <ShareIcon fontSize="small" />}
              {slug === SLUG_BACK && <ArrowBackIcon fontSize="small" />}
              {slug === SLUG_DOWNLOAD && <FileDownloadIcon fontSize="small" />}
              <Typography variant={"body1"}>{title}</Typography>
            </Stack>
          ) : (
            <Typography variant={"body1"} className={mainCta}>
              {title}
            </Typography>
          )
        ) : (
          <Typography variant={"body1"} className={mainCta}>
            <CircularProgress
              color={"inherit"}
              className={loaderStyle}
              size={20}
            />
          </Typography>
        )}
      </Box>
    </Button>
  );
};

CustomButton.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(useStyles, { withTheme: true })(CustomButton);
